<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="this.selected.nudgeWidth"
    origin="right top"
    transition="scale-transition"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn text icon dark small v-on="on">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-card ma-0 pa-0>
      <v-list>
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-icon x-large color="secondary">mdi-account-circle</v-icon>
            <!-- <img src="https://randomuser.me/api/portraits/men/81.jpg" /> -->
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              {{ user.attributes.name }} {{ user.attributes.family_name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ user.attributes["email"] }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list
        v-if="typeof selected.view === 'undefined'"
        transition="fade-transition"
      >
        <v-list-item-group v-model="item">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            v-on:click="setView(item)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title >{{ $Amplify.I18n.get(item.text) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-card
        elevation="0"
        class="ma-0 pa-0"
        v-if="typeof selected.view != 'undefined'"
        :max-width="selected.nudgeWidth + 40"
      >
        <v-card-title>
          <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn text icon small v-on="on" v-on:click="setView({})">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>{{ $Amplify.I18n.get("Back to menu") }}</span>
          </v-tooltip>

          <v-icon color="secondary" x-large left>
            {{ selected.icon }}
          </v-icon>
          <span class="title font-weight-regular">{{
            $Amplify.I18n.get(selected.text)
          }}</span>
        </v-card-title>

        <v-card-text v-if="selected.view == 'account'">
          <custom-edit-user v-bind:editUserConfig="editUserConfig" />
        </v-card-text>

        <v-card-text v-if="selected.view == 'security'">
          <custom-amplify-set-mfa v-bind:mfaConfig="mfaConfig" />
        </v-card-text>

        <v-card-text v-if="selected.view == 'settings'">
          <v-container fluid grid-list-xs>
            <v-layout wrap>
              <v-flex>
                <span class="subtitle-1 font-weight-regular">{{
                  $Amplify.I18n.get("Select language")
                }}</span>
              </v-flex>
              <v-flex shrink>
                <language></language>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-text v-if="selected.view == 'password'">
          <custom-change-password />
        </v-card-text>
      </v-card>

      <v-card-actions v-if="typeof selected.view === 'undefined'">
        <custom-amplify-sign-out />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { Auth, Logger } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import Language from "@/components/Language";
import { editUserConfig } from "@/components/authenticator/config";

const logger = new Logger("UserComponent");
export default {
  components: {
    Language
  },
  data() {
    return {
      error: "",
      logger: {},
      item: 1,
      items: [
        {
          text: "My Account",
          icon: "mdi-account",
          view: "account",
          nudgeWidth: 350
        },
        {
          text: "Preferences",
          icon: "mdi-settings",
          view: "settings",
          nudgeWidth: 300
        },
        {
          text: "Security",
          icon: "mdi-shield-account",
          view: "security",
          nudgeWidth: 450
        },
        {
          text: "Change Password",
          icon: "mdi-key",
          view: "password",
          nudgeWidth: 350
        }
      ],
      menu: false,
      selected: {},
      mfaConfig: {
        mfaTypes: ["SMS", "TOTP", "None"],
        hideCancelButton: true
      },
      editUserConfig
    };
  },
  methods: {
    signOut: function() {
      Auth.signOut()
        .then(() => {
          logger.debug("sign out success");
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(err => console.log(err));
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
    setView: function(item) {
      logger.debug(`Menu Selected: ${item}`);
      this.selected = item;
    },
    setDefault: function() {
      logger.debug(`Menu Selected`);
      this.selected = {};
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    menu(val) {
      if (!val) {
        //Clean item selected when close menu
        this.selected = {};
      }
    }
  }
};
</script>
